import type { ProjectStatus } from '@/lib/mockData'

const statusConfig: Record<ProjectStatus, { label: string; className: string }> = {
  live: { label: 'Live', className: 'bg-lime-400/10 text-lime-400 border-lime-400/30' },
  upcoming: { label: 'Upcoming', className: 'bg-white/10 text-white border-white/20' },
  ended: { label: 'Ended', className: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/30' },
  success: { label: 'Sold Out', className: 'bg-orange-400/10 text-orange-400 border-orange-400/30' },
  failed: { label: 'Failed', className: 'bg-red-500/10 text-red-400 border-red-500/30' },
}

function StatusBadge({ status }: { status: ProjectStatus }) {
  const config = statusConfig[status]
  return (
    <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] ${config.className}`}>
      <span className={`h-1.5 w-1.5 rounded-full bg-current ${status === 'live' ? 'animate-pulse' : ''}`} />
      {config.label}
    </span>
  )
}

export default StatusBadge
